// extracted by mini-css-extract-plugin
export default {"button":"SocialIconLink_button__5KMeq"};